import React from 'react'
import { useAuth } from '@modmd/data'
import { PersonalPageLayout } from 'client-portal/components/PageLayout'
import { Container } from 'components/Layout'
import { VaccineCard } from 'sharedComponents/VaccineRecord'
import Card from 'components/Card'

export const Vaccine = () => {
  const auth = useAuth()
  return (
    <PersonalPageLayout title="Vaccine">
      <Container>
        <Card>
          <VaccineCard isEditable={false} isPhotoEnabled userId={auth.data.User?.id?.toString()} />
        </Card>
      </Container>
    </PersonalPageLayout>
  )
}
